export const init = () => {
  // Check if container exists & init slider
  const slickBrands = $('.slick-brands');
  if (slickBrands.length === 0) return;

  $('.slick-brands').slick({
    dots: true,
    infinite: false,
    speed: 300,
    rows: 3,
    slidesPerRow: 5,
    slidesToScroll: 1,
    useCSS: true,
    useTransform: true,
    variableWidth: false,
    responsive: [
      {
        breakpoint: cube.constants.breakpointLg,
        settings: { slidesPerRow: 4 },
      },
      {
        breakpoint: 961,
        settings: { slidesPerRow: 3 },
      },
      {
        breakpoint: cube.constants.breakpointSm,
        settings: { arrows: false, slidesPerRow: 2 },
      },
      {
        breakpoint: cube.constants.breakpointXs,
        settings: { arrows: false, slidesPerRow: 1 },
      },
    ],
  });
};



// WEBPACK FOOTER //
// ./src/homepage/sliders/home-slider-brands.js